var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('modal',{attrs:{"size":"auth"},on:{"close":_vm.close}},[[_vm._v("\n         \n    ")],_c('template',{slot:"body"},[_c('auth-component',{on:{"success":_vm.close}})],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }